/*
 * Copyright 2022-2024 NXGN Management, LLC. All Rights Reserved.
 */

import { Component, OnInit } from "@angular/core";
import { AuthService, EventQueueService } from "./services";
import { AppEventType } from "./app-event-type.enum";
import { AppEvent } from "./models";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {
  title = "mfss-mfgateway-provisioning-ui";
  menuCollapsed = false;
  isUserLogged = false;

  constructor(private eventQueueService: EventQueueService, private authService: AuthService) {}

  ngOnInit(): void {
    this.eventQueueService.on(AppEventType.menuCollapse).subscribe(() => this.handleMenuToggle());
    this.isUserLogged = this.authService.isUserLogged();
    if (!this.isUserLogged) {
      this.eventQueueService.dispatch(new AppEvent(AppEventType.menuCollapse));
    }

    this.inactivityTimeout();
  }

  handleMenuToggle(): void {
    this.menuCollapsed = !this.menuCollapsed;
  }

  inactivityTimeout(): void {
    let time: any; // Holder for timeout

    const INACTIVITY_TIMEOUT = 900000; // 15 minutes

    const logout = () => {
      window.sessionStorage.clear();
      window.localStorage.clear();
      document.cookie.split(";").forEach((c) => {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      });
      window.location.href = "/user/login";
      window.location.reload();
    };

    const resetTimer = () => {
      clearTimeout(time);
      time = setTimeout(logout, INACTIVITY_TIMEOUT);
    };

    window.addEventListener("load", resetTimer, true);
    const domEvents = ["mousedown", "mousemove", "keypress", "scroll", "touchstart"];
    domEvents.forEach((event) => {
      document.addEventListener(event, resetTimer, true);
    });

    window.onload = resetTimer;
  }
}
